export const ErrorElement = () => {
  return (
    <div role="alert" style={{ padding: 40 }}>
      <h1>Something went wrong!</h1>
      <p>Please try again later.</p>
    </div>
  );
};
